import { createSonarSelector } from '@lib/selectors';
import { useSonarSelector } from '@hooks';

import { DataSecurityApplicationReference, DataSecurityApplicationStatus } from '@sonar-software/sonar-core';

const mapSelector = createSonarSelector((state) => state.core.dataSecurity.applications.byIdMap);

const emptyMap: Record<number, DataSecurityApplicationReference> = {};
const empty: DataSecurityApplicationReference = {
	activityPeriod: 0,
	installed: false,
	integrationUser: '',
	monitors: [],
	name: '',
	stakeholderIds: [],
	status: DataSecurityApplicationStatus.Added
};

export function useApplicationReferences(): Record<number, DataSecurityApplicationReference> {
	return useSonarSelector((state) => mapSelector(state).data ?? emptyMap);
}

export function useApplicationReference(applicationId: number): DataSecurityApplicationReference {
	return useApplicationReferences()[ applicationId ] ?? empty;
}
